import React, { useState } from 'react';
import { Button, Card, ErrorAlert } from '../../../components/shared';

export default function VdscLinkFlow({ onSubmitLink, onBack, loading, error }) {
  const [idNumber, setIdNumber] = useState('');
  const [fullName, setFullName] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmitLink({ idNumber, fullName });
  };

  return (
    <div className="mx-auto max-w-md">
      <Card>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Liên kết tài khoản Rồng Việt</h3>
            <p className="mt-1 text-sm text-gray-500">
              Nhập thông tin tài khoản chứng khoán Rồng Việt hiện có của bạn
            </p>
          </div>

          <div className="space-y-4">
            <div>
              <label className="mb-1.5 block text-sm font-medium text-gray-700">Số CMND/CCCD</label>
              <input
                type="text"
                value={idNumber}
                onChange={(e) => setIdNumber(e.target.value)}
                placeholder="Nhập số CMND hoặc CCCD"
                className="w-full rounded-lg border border-gray-300 px-3 py-2.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div>
              <label className="mb-1.5 block text-sm font-medium text-gray-700">Họ và tên</label>
              <input
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="Nhập họ và tên chủ tài khoản"
                className="w-full rounded-lg border border-gray-300 px-3 py-2.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
          </div>

          <ErrorAlert error={error} />

          <div className="flex gap-3">
            <Button variant="secondary" className="flex-1" onClick={onBack} type="button">
              Quay lại
            </Button>
            <Button className="flex-1" type="submit" loading={loading} disabled={!idNumber || !fullName}>
              Liên kết
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
}
